import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import ImageContainer from '@Components/ImageContainer'
import Breakpoint from '@Components/breakpoint'
import HubLogo from '@App/components/HubLogo'
import PostSlab from './PostSlab'

type props = {
  withCoverLogo: boolean
  coverLogoUrl: string
  isOrg: boolean
  backgroundUrl: string
  isTintVisible: boolean
  tintStyles: CSSProperties
}

const Placeholder: React.FC<props> = (props: props) => {
  const { withCoverLogo, coverLogoUrl, isTintVisible, backgroundUrl, tintStyles, isOrg } = props

  const getPostSlabs = () => {
    const n = isOrg ? 3 : 2

    return [...new Array(n * 2)].map((item, index) => (
      <PostSlab key={index} numberOfPosts={n} isOrg={isOrg} />
    ))
  }

  return (
    <Container>
      <Cover>
        <CoverImage op="cover" url={backgroundUrl} />
        {withCoverLogo && <Logo url={coverLogoUrl} useImageContainer />}
        {isTintVisible ? <Tint style={tintStyles} /> : null}
      </Cover>
      <Nav />
      <Breakpoint>
        <Placeholders>{getPostSlabs()}</Placeholders>
      </Breakpoint>
    </Container>
  )
}

export default Placeholder

const Container = styled.div`
  height: 100vh;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.grayLighter};

  .px-sparq-footer {
    z-index: 10010;
  }
`

const Cover = styled.div`
  position: relative;
  width: 100%;
  height: 50%;
`

const CoverImage = styled(ImageContainer)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`

const Logo = styled(HubLogo)`
  position: absolute;
  width: 100%;
  top: 25%;
`

const Tint = styled.div`
  position: absolute;
  top: -25%;
  left: 0;
  height: 125%;
  width: 100%;
  opacity: 0.25;
  background-color: #000000;
  transform: translateZ(0);
`

const Nav = styled.div`
  position: relative;
  height: 40px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 1;
  background-color: #ffffff;
`

const Placeholders = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`
